import * as React from 'react'

const ApplicationContext = React.createContext({
  game: ''
})

export default ApplicationContext